module.exports = __webpack_public_path__ + "img/上海交通大学.1ed3e7a5.png";